import { useAppDispatch } from '@customer/store/hooks';
import { RefObject, useCallback, useRef } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { Action } from '@reduxjs/toolkit';

interface ReturnControlProps<T> {
  // TODO: After upgrading to React 19, replace elementRef with ref since forwardRef is deprecated.
  // https://react.dev/reference/react/forwardRef
  elementRef: RefObject<HTMLVdsBasicDropdownElement>;
  items: DropdownItemProps<T>[];
  onChange: (newValue: T) => void;
}

export const useDropdown = <T>(
  useItemsHook: () => DropdownItemProps<T>[],
  onChangeAction: (payload: T) => Action,
): ReturnControlProps<T> => {
  const dispatch = useAppDispatch();

  const elementRef = useRef<HTMLVdsBasicDropdownElement>(null);

  const items = useItemsHook();

  const onChange = useCallback(
    (newValue: T) => {
      dispatch(onChangeAction(newValue));
    },
    [dispatch, onChangeAction],
  );

  return { elementRef, items, onChange };
};

export default useDropdown;
